export { default } from './AwardsPanel';